/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const SocialCircleYoutubeIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, fillRule: "evenodd", d: "M12 21a9 9 0 100-18 9 9 0 000 18z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.392 9.33c-0.26-0.459-0.543-0.543-1.118-0.575C14.699 8.716 13.254 8.7 12 8.7S9.3 8.716 8.725 8.754c-0.574 0.033-0.857 0.117-1.12 0.577C7.338 9.789 7.2 10.58 7.2 11.97v0.004c0 1.386 0.138 2.182 0.406 2.636 0.263 0.46 0.546 0.543 1.12 0.581 0.575 0.034 2.02 0.053 3.275 0.053 1.252 0 2.698-0.02 3.273-0.052 0.576-0.039 0.858-0.122 1.119-0.581 0.27-0.454 0.407-1.25 0.407-2.636V11.97c0-1.391-0.137-2.182-0.408-2.64zM10.8 13.759v-3.57l3 1.785-3 1.785z", clipRule: "evenodd" })));
};
//# sourceMappingURL=SocialCircleYoutubeIcon.js.map